import React, {useMemo} from 'react';
import {Props} from './Props';
import {formatDateTime, createValidDate} from '../../utils/DateUtil';

const DateTimeFormatted: React.FunctionComponent<Props> = ({dateTime}) => {
    const dateFormatted = useMemo(() => {
        const date = createValidDate(dateTime);
        if (!date) {
            return <>-</>;
        }

        return formatDateTime(date);
    }, [dateTime]);

    return <span>{dateFormatted}</span>;
};

export default DateTimeFormatted;
